const originalFetch = window.fetch;
const isDev = import.meta.env.DEV;

window.fetch = async (...args: Parameters<typeof fetch>) => {
  const url = typeof args[0] === 'string' ? args[0] : args[0].url;

  try {
    const response = await originalFetch(...args);

    if (isDev && !response.ok && response.status >= 500) {
      console.warn('Server error:', { url, status: response.status });
    }

    return response;
  } catch (error) {
    if (error instanceof TypeError && error.message.includes('Content Security Policy')) {
      console.error('CSP error:', url);
    }
    throw error;
  }
};
